import { render } from "./UserPostReaction.vue?vue&type=template&id=2497e0f2"
import script from "./UserPostReaction.vue?vue&type=script&lang=js"
export * from "./UserPostReaction.vue?vue&type=script&lang=js"
script.render = render

export default script